export const informationIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.117 6.673c-1.872-.01-3.924.01-5.702.007v2.416H7.96v8.628H6.32v2.31h7.157v-2.31h-1.36zM10 5.032c1.397 0 2.243-.93 2.243-2.08-.027-1.173-.847-2.074-2.186-2.074s-2.214.9-2.214 2.074c-.001 1.15.847 2.08 2.157 2.08z"/></svg>`,
  name: 'information',
};
